import { render, staticRenderFns } from "./ReferralPool.vue?vue&type=template&id=2bb3531a"
import script from "./ReferralPool.vue?vue&type=script&lang=js"
export * from "./ReferralPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports